module.exports = __webpack_public_path__ + "media/greenhouse-fullhd03.ba87a388.mp4";